module.exports = {
  entity: ( $stateParams, Api ) ->
    Api.Entity.get({ id: $stateParams.entityId }).$promise
}
